/**
 * Shared sport checks. `clubs.sport` is free text (data/sports.js offers
 * "Rugby Union"; "Other" takes whatever the founder typed), so compare it
 * case- and space-insensitively.
 *
 * Pure, no imports: backend `node --test` loads it (test/tourListing.test.js).
 * First used by B-44.1 Tours & festivals; B-42 Coaches Corner is to switch
 * its own copy over to this one.
 */

const squash = (sport) => String(sport || '').toLowerCase().replace(/\s+/g, '');

/** "Rugby Union" / "rugby union" / "Rugby" → true. Touch, tag, league, sevens-only labels etc. → false. */
export const isRugbyUnion = (sport) => ['rugby', 'rugbyunion'].includes(squash(sport));
